import { render, staticRenderFns } from "./rolejob.vue?vue&type=template&id=354e14a2&scoped=true&"
import script from "./rolejob.vue?vue&type=script&lang=js&"
export * from "./rolejob.vue?vue&type=script&lang=js&"
import style0 from "./rolejob.vue?vue&type=style&index=0&id=354e14a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e14a2",
  null
  
)

export default component.exports